import React from "react";
import { Input } from "../../hooks/Input";

export const CurrentProgramDialog = ({ unitId, ecSp, ecA, ecB, ecC }) => {

    return <div>
        <div className="ph-dialog" draggable="false">
            <div className="row-ph-dialog ph-level-row">
                <p>EC (мС/см)</p>
                <Input
                    value={ecSp}
                    ckey={'ecSp'}
                    min={0}
                    max={5}
                    mode={0.01}
                    round={100}
                    deviceId={unitId}
                />
            </div>
            <div className="row-ph-dialog ph-level-row">
                <p>Компонент A</p>
                <Input
                    value={ecA}
                    ckey={'ecA'}
                    min={0}
                    max={100}
                    mode={1}
                    deviceId={unitId}
                />
            </div>
            <div className="row-ph-dialog ph-level-row">
                <p>Компонент B</p>
                <Input
                    value={ecB}
                    ckey={'ecB'}
                    min={0}
                    max={100}
                    mode={1}
                    deviceId={unitId}
                />
            </div>
            <div className="row-ph-dialog ph-level-row">
                <p>Компонент C</p>
                <Input
                    value={ecC}
                    ckey={'ecC'}
                    min={0}
                    max={100}
                    mode={1}
                    deviceId={unitId}
                />
            </div>
        </div>
    </div>
}